import useLocalStorage from './useLocalStorage';
export default function useLogoutRoute() {
    const [logoutRoute, setLogoutRoute, resetLogoutRoute] = useLocalStorage('logoutRoute', null);
    return { logoutRoute, setLogoutRoute, resetLogoutRoute };
}
